import { render, staticRenderFns } from "./ExistingVendorSelfRegistration.vue?vue&type=template&id=261d4116&"
import script from "./ExistingVendorSelfRegistration.vue?vue&type=script&lang=js&"
export * from "./ExistingVendorSelfRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ExistingVendorSelfRegistration.vue?vue&type=style&index=0&id=261d4116&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports